import axiosInstance from 'src/utils/axios';
import {
  FlightCalculatorDefaultSettingsPayload,
  FlightCalculatorDefaultSettingsResponse,
  FlightCalculatorSettingsResponse,
  FlightCalculatorSettingsSavePayload,
  FlightCalculatorSettingsUpdatePayload,
} from './flight-calculator.types';

//
//

const BASE_URL = '/cms/v1/component-settings/flight-calculator';

//

export const getFlightCalculatorDefaultSettingsByMerchantCodeAPI = async (
  payload: FlightCalculatorDefaultSettingsPayload
): Promise<FlightCalculatorDefaultSettingsResponse> => {
  const { merchantCode } = payload;

  const response = await axiosInstance.get<FlightCalculatorDefaultSettingsResponse>(
    `/cms/v1/components/flight-calculator`,
    {
      params: { merchantCode },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getFlightCalculatorSettingsByMerchantCodeAPI = async (
  payload: FlightCalculatorDefaultSettingsPayload
): Promise<FlightCalculatorSettingsResponse> => {
  const { merchantCode } = payload;

  const response = await axiosInstance.get<FlightCalculatorSettingsResponse>(`${BASE_URL}/active`, {
    params: { merchantCode },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const saveFlightCalculatorSettingsAPI = async (
  payload: FlightCalculatorSettingsSavePayload
): Promise<FlightCalculatorSettingsResponse> => {
  const { merchantCode, data } = payload;

  const response = await axiosInstance.post<FlightCalculatorSettingsResponse>(
    `${BASE_URL}`,
    JSON.stringify(data)
  );

  if (!response?.data) throw new Error('Unexpected API response');

  const activityCalculatorId = response.data?.id;
  if (activityCalculatorId && merchantCode) {
    await connectMerchantToFlightCalculatorAPI(merchantCode, activityCalculatorId);
  }

  return response.data;
};

const connectMerchantToFlightCalculatorAPI = async (
  merchantCode: string,
  activityCalculatorId: string
) => {
  return axiosInstance.post(`${BASE_URL}/${activityCalculatorId}/merchant/${merchantCode}`);
};

export const updateFlightCalculatorSettingsAPI = async (
  payload: FlightCalculatorSettingsUpdatePayload
): Promise<FlightCalculatorSettingsResponse> => {
  const { id, data } = payload;

  const response = await axiosInstance.put<FlightCalculatorSettingsResponse>(
    `${BASE_URL}/${id}`,
    data
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
